const setting = require('./setting')
module.exports = Object.assign({}, setting)
